import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IRecent } from '../types/IRecent';
import { IViewUsageInfo } from '../types/IUsageInfo';
import { IUser } from '../types/IUser';
import { IView } from '../types/IView';
import { IVizRecommendation } from '../types/IVizRecommendation';
import { IWorkbookParent } from '../types/IWorkbook';
import { INamedItem } from '../types/resourceParts';
import { Request } from './Request';

export interface IGetRecommendationsVizzesParams extends IGetItemsParams {
}

export interface IGetRecommendationsVizzesResult extends IGetItemsResult {
  // TODO clean up unnecessary fields after STORY 897772
  views?: IView[];
  workbooks?: IWorkbookParent[];
  projects?: INamedItem[];
  users?: IUser[];
  maxStats?: IViewUsageInfo;
  favorites?: string[];
  recents?: IRecent[];
  viewMaxStats?: IViewUsageInfo;
  recommendations?: IVizRecommendation[];
}

export class GetRecommendationsVizzesRequest extends Request<IGetRecommendationsVizzesParams, IGetRecommendationsVizzesResult> {
  constructor(params: IGetRecommendationsVizzesParams) {
    super('getRecommendationsVizzes', params);
  }
}
